import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

/* eslint-disable react/jsx-one-expression-per-line */

/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeTitle } from './mixins';
var H1 = styled.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeTitle(props);
});
var H2 = styled.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeTitle(props);
});
var H3 = styled.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeTitle(props);
});
var H4 = styled.h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeTitle(props);
});
var H5 = styled.h5(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeTitle(props);
});
export var Title = function Title(props) {
  var level = props.level,
      children = props.children;
  var as = "h".concat(level);

  var getHeading = function getHeading() {
    switch (level) {
      case 1:
        return React.createElement(H1, Object.assign({}, props, {
          as: as
        }), children);

      case 2:
        return React.createElement(H2, Object.assign({}, props, {
          as: as
        }), children);

      case 3:
        return React.createElement(H3, Object.assign({}, props, {
          as: as
        }), children);

      case 4:
        return React.createElement(H4, Object.assign({}, props, {
          as: as
        }), children);

      case 5:
        return React.createElement(H5, Object.assign({}, props, {
          as: as
        }), children);

      default:
        return React.createElement(H1, Object.assign({}, props, {
          as: as
        }), children);
    }
  };

  return getHeading();
};
Title.propTypes = {
  children: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired // variant: PropTypes.string.isRequired,

};